import { cx } from 'cvb';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import apiConfig from '../../../config/api/apiConfig';
import SizeChartTable from '../../Size/SizeChartTable/SizeChartTable';
import { DrawerTabStyles } from './DrawerTab.style';

const DrawerTab = ({
  onLoad,
  sizeChartName,
  sizeChartUrl,
  regionCode,
  isActiveTabAssistentePersonal,
  onOpenSizeChart,
  tabHeadings,
  sizeChartTable,
  hasSizeChartTable,
  brandLogoUrl,
  appCtx,
}) => {
  const [activeTab, setActiveTab] = useState(1);

  const toggleTab = (id) => {
    setActiveTab(id);
    if (id === 1) {
      onOpenSizeChart();
    }
  };

  useEffect(() => {
    if (hasSizeChartTable) {
      setActiveTab(1);
      onOpenSizeChart();
    } else if (isActiveTabAssistentePersonal) {
      setActiveTab(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasSizeChartTable, isActiveTabAssistentePersonal]);

  const renderIframe = () => {
    return (
      <iframe
        className="sizechart-template"
        id="testId-sizeChart-iframe"
        title={sizeChartName}
        onLoad={onLoad}
        src={apiConfig.getSizeCharturl(sizeChartUrl, regionCode)}
      />
    );
  };

  const tabContent = (id) => {
    if (id === 1) {
      return (
        <div className="sizechart-container">
          {hasSizeChartTable ? (
            <SizeChartTable sizeChartTable={sizeChartTable} brandLogoUrl={brandLogoUrl} appCtx={appCtx} />
          ) : (
            renderIframe()
          )}
        </div>
      );
    }

    return <div id="personal-assistant-container" className="personal-assistant-tab-container" />;
  };

  return (
    <div className="drawer-tab">
      {!hasSizeChartTable && (
        <ul>
          {isActiveTabAssistentePersonal && (
            <li>
              <button
                className={cx('tab-button personal-assistant', activeTab === 0 && 'tab-active')}
                type="button"
                onClick={() => toggleTab(0)}
                disabled={activeTab === 0}
              >
                {tabHeadings[0]}
              </button>
            </li>
          )}
          <li>
            <button
              className={cx('tab-button guide-sizes', activeTab === 1 && 'tab-active')}
              type="button"
              onClick={() => toggleTab(1)}
              disabled={activeTab === 1}
            >
              {tabHeadings[1]}
            </button>
          </li>
        </ul>
      )}

      <div className="drawer-tab-content">{tabContent(activeTab)}</div>
      <style jsx>{DrawerTabStyles}</style>
    </div>
  );
};

DrawerTab.defaultProps = {
  isActiveTabAssistentePersonal: false,
  sizeChartTable: null,
  hasSizeChartTable: false,
  sizeChartUrl: '',
  brandLogoUrl: null,
  appCtx: {},
};

DrawerTab.propTypes = {
  onLoad: PropTypes.func.isRequired,
  sizeChartName: PropTypes.string.isRequired,
  sizeChartUrl: PropTypes.string,
  regionCode: PropTypes.string.isRequired,
  isActiveTabAssistentePersonal: PropTypes.bool,
  onOpenSizeChart: PropTypes.func.isRequired,
  tabHeadings: PropTypes.object.isRequired,
  sizeChartTable: PropTypes.shape({
    activeSizeType: PropTypes.string,
    columns: PropTypes.arrayOf(PropTypes.string),
    rows: PropTypes.arrayOf(PropTypes.object),
  }),
  hasSizeChartTable: PropTypes.bool,
  brandLogoUrl: PropTypes.string,
  appCtx: PropTypes.object,
};

export default DrawerTab;
